import { Button, Modal } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";

type ConfirmationModalProps = {
  isOpen: boolean;
  title: string;
  message: string;
  onClose: () => void;
  onConfirm: () => void;
  isConfirming?: boolean;
};

export function ConfirmationModal({
  isOpen,
  title,
  message,
  onClose,
  onConfirm,
  isConfirming = false,
}: ConfirmationModalProps) {
  return (
    <Modal show={isOpen} size="md" onClose={onClose} popup>
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
          <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
            {title}
          </h3>
          <p className="mb-5 text-sm text-gray-500 dark:text-gray-400">
            {message}
          </p>
          <div className="flex justify-center gap-4">
            <Button
              color="failure"
              onClick={onConfirm}
              isProcessing={isConfirming}
              disabled={isConfirming}
            >
              {isConfirming ? "Confirmando..." : "Sim, tenho certeza"}
            </Button>
            <Button color="gray" onClick={onClose} disabled={isConfirming}>
              cancelar
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
